import n from "react";
var o = require("qrcode");
function t() {
  var t = function t(_t) {
    var i = _t.text,
      r = _t.options,
      e = _t.logo,
      u = n.useRef(null);
    return n.useEffect(function () {
      var n, t, l, v, a, d, c, f, s;
      if (u && u.current && (o.toCanvas(u.current, i, r, function (n) {
        if (n) throw n;
      }), e)) {
        var p = u.current.getContext("2d");
        if (p) {
          var m = new Image();
          m.src = e.src;
          var w = (null === (n = null == e ? void 0 : e.options) || void 0 === n ? void 0 : n.width) || 30;
          if ((null === (t = null == e ? void 0 : e.options) || void 0 === t ? void 0 : t.hasOwnProperty("x")) && (null === (l = null == e ? void 0 : e.options) || void 0 === l ? void 0 : l.hasOwnProperty("y"))) {
            var g = (null === (v = null == e ? void 0 : e.options) || void 0 === v ? void 0 : v.x) || 0,
              h = (null === (a = null == e ? void 0 : e.options) || void 0 === a ? void 0 : a.y) || 0;
            m.onload = function () {
              p.drawImage(m, g, h, w, w);
            };
          }
          if (!(null === (d = null == e ? void 0 : e.options) || void 0 === d ? void 0 : d.hasOwnProperty("x")) || !(null === (c = null == e ? void 0 : e.options) || void 0 === c ? void 0 : c.hasOwnProperty("y")) || void 0 === (null === (f = null == e ? void 0 : e.options) || void 0 === f ? void 0 : f.x) || void 0 === (null === (s = null == e ? void 0 : e.options) || void 0 === s ? void 0 : s.y)) {
            var x = null == r ? void 0 : r.margin;
            x = x ? 8 * x : 0 === x ? 0 : 32;
            var y = (((null == r ? void 0 : r.width) || 116 + x) - w) / 2;
            m.onload = function () {
              p.drawImage(m, y, y, w, w);
            };
          }
        }
      }
    }, [u, i, r, e]), /*#__PURE__*/n.createElement("canvas", {
      ref: u
    });
  };
  return n.useMemo(function () {
    return t;
  }, []);
}
function i() {
  var i, r;
  return {
    Image: (i = function i(t) {
      var i = t.text,
        r = t.options,
        e = n.useRef(null);
      return n.useEffect(function () {
        e && e.current && o.toDataURL(i, r, function (n, o) {
          if (n) throw n;
          e.current instanceof HTMLImageElement && (e.current.src = o);
        });
      }, [i, r, e]), /*#__PURE__*/n.createElement("img", {
        ref: e
      });
    }, n.useMemo(function () {
      return i;
    }, [])),
    Canvas: t(),
    SVG: (r = function r(t) {
      var i = t.text,
        r = t.options,
        e = n.useRef(null);
      return n.useEffect(function () {
        o.toString(i, r, function (n, o) {
          if (n) throw n;
          e.current instanceof HTMLDivElement && (e.current.innerHTML = o);
        });
      }, [i, r]), /*#__PURE__*/n.createElement("div", {
        ref: e
      });
    }, n.useMemo(function () {
      return r;
    }, []))
  };
}
export { i as useQRCode };